import React from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import { onCLS, onINP, onLCP } from 'web-vitals'

import App from './App'

// Project styles (imports elSDK styles from @elsapiens/styles + accounting-specific)
import './index.css'

// elSDK wave-canvas: auto-enhances .el-bg-waves elements with interactive canvas animation
import '@elsapiens/styles/wave-canvas'

// Monitor Core Web Vitals in development
if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  onCLS((metric) => { console.log('[Web Vitals] CLS:', metric.value.toFixed(4), metric) })
  // eslint-disable-next-line no-console
  onINP((metric) => { console.log('[Web Vitals] INP:', metric.value.toFixed(0), 'ms', metric) })
  // eslint-disable-next-line no-console
  onLCP((metric) => { console.log('[Web Vitals] LCP:', metric.value.toFixed(0), 'ms', metric) })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

const rootElement = document.getElementById('root')
if (!rootElement) {throw new Error('Root element not found')}
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
